export const VOUCHER_ROUTING = [
    {
        path: '/voucher',
        name: 'voucher',
        meta: {
            auth: true,
            breadcrumb: [
                { name: 'Mã giảm giá', pathName: 'voucher', icon: 'fa fa-gift' },
            ]
        },
        component: () => import('./Voucher.vue'),
        redirect: { name: 'voucher-index' },
        children: [
            {
                path: '/voucher.html',
                name: 'voucher-index',
                component: () => import('./list/List.vue'),
            },
        ]
    }
];